var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestionsTaken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#0E4A69",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h28v28H10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.65 35.624a11.16 11.16 0 0 0 4.498-.915 11.908 11.908 0 0 0 6.22-6.22c.607-1.4.91-2.898.91-4.493 0-1.595-.303-3.092-.91-4.492a11.865 11.865 0 0 0-2.518-3.709 11.845 11.845 0 0 0-3.714-2.518 11.224 11.224 0 0 0-4.498-.909c-1.58 0-3.07.303-4.474.91a11.845 11.845 0 0 0-3.715 2.517 11.865 11.865 0 0 0-2.518 3.709c-.606 1.4-.91 2.897-.91 4.492 0 1.595.306 3.092.916 4.492.61 1.4 1.45 2.634 2.518 3.703a11.908 11.908 0 0 0 3.709 2.518c1.403.61 2.899.915 4.486.915zm-.264-9.26c-.693 0-1.04-.322-1.04-.968v-.144c0-.55.137-.995.412-1.334.276-.339.62-.656 1.035-.95.503-.36.88-.66 1.13-.904.252-.243.378-.556.378-.94 0-.414-.148-.749-.443-1.004-.295-.255-.69-.383-1.184-.383-.367 0-.684.086-.951.257a2.263 2.263 0 0 0-.688.712l-.479.539c-.135.151-.367.227-.694.227a.983.983 0 0 1-.646-.227c-.183-.152-.275-.367-.275-.646a1.552 1.552 0 0 1 .12-.599c.167-.55.574-1.024 1.22-1.423s1.475-.598 2.488-.598c.678 0 1.306.117 1.884.353a3.301 3.301 0 0 1 1.394 1.028c.351.451.526 1.007.526 1.67 0 .685-.179 1.23-.538 1.632-.359.403-.825.792-1.4 1.167-.39.255-.687.5-.89.735a1.267 1.267 0 0 0-.318.82v.131a.802.802 0 0 1-.293.61c-.187.16-.436.24-.748.24zm-.011 3.554c-.36 0-.672-.12-.94-.36-.267-.239-.4-.538-.4-.896 0-.351.131-.648.394-.892.264-.243.579-.365.946-.365.366 0 .68.12.939.36.259.239.388.538.388.897 0 .366-.13.667-.388.903-.26.235-.573.353-.94.353z",
    fill: "#43B7F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionsTaken);
export default __webpack_public_path__ + "static/media/icon-questions-taken.1d6fe808.svg";
export { ForwardRef as ReactComponent };